import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { styles } from "../styles";

const Hero = ({ animations, isMobile, scrollToSection }) => {
  return (
    <section className="relative h-screen flex items-center">
      {/* Background */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('images/landing/bg.png')",
            backgroundAttachment: isMobile ? "scroll" : "fixed",
          }}
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div
        className={`relative ${styles.container} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
      >
        {/* Left Content */}
        <motion.div
          initial="initial"
          animate="animate"
          variants={animations.staggerChildren}
          className="space-y-8"
        >
          <motion.div variants={animations.fadeInUp}>
            <span className="inline-block px-4 py-2 rounded-lg bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-6">
              Cathodic Protection Specialist
            </span>
          </motion.div>

          <motion.h1
            variants={animations.fadeInUp}
            className={`${styles.sectionTitle} text-white leading-tight mb-6`}
          >
            PT ADHIM AJU SEJAHTERA
          </motion.h1>

          <motion.p
            variants={animations.fadeInUp}
            className="text-xl md:text-2xl text-white/90 leading-relaxed max-w-2xl mb-8"
          >
            Providing solution for corrosion mitigation
            <br />
            and thermal loss can be overcome
          </motion.p>

          <motion.div
            variants={animations.fadeInUp}
            className="flex flex-col sm:flex-row gap-4"
          >
            <button
              onClick={() => scrollToSection("about-us")}
              className={`${styles.button} px-6 py-3 rounded-lg text-white font-medium flex items-center gap-2 group`}
            >
              Our Solutions
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>

            <button className="px-6 py-3 rounded-lg border border-white/30 text-white font-medium hover:bg-white/5 transition-colors">
              Our Products
            </button>
          </motion.div>
        </motion.div>

        {/* Right Content - Key Features */}
        {/* <motion.div
          initial="initial"
          animate="animate"
          variants={animations.staggerChildren}
          className="space-y-6"
        >
          <motion.div
            variants={animations.fadeInUp}
            className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="p-3 bg-primary/20 rounded-lg">
                <Shield className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-white">
                ICCP & SACP Systems
              </h3>
            </div>
            <p className="text-white/70">
              Complete cathodic protection solutions for pipeline, tank, and
              marine structures.
            </p>
          </motion.div>

          <motion.div
            variants={animations.fadeInUp}
            className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="p-3 bg-primary/20 rounded-lg">
                <Zap className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-white">
                Innovation & Research
              </h3>
            </div>
            <p className="text-white/70">
              Developing cutting-edge corrosion monitoring and prevention
              technologies.
            </p>
          </motion.div>

          <motion.div
            variants={animations.fadeInUp}
            className="grid grid-cols-3 gap-4 pt-4"
          >
            <div className="text-center">
              <div className="text-2xl font-bold text-white">25+</div>
              <div className="text-white/60 text-sm">Years</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">500+</div>
              <div className="text-white/60 text-sm">Projects</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">ISO</div>
              <div className="text-white/60 text-sm">Certified</div>
            </div>
          </motion.div>
        </motion.div> */}
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="w-px h-12 bg-gradient-to-b from-transparent via-white/60 to-transparent"
        />
      </motion.div>
    </section>
  );
};

export default Hero;
